module.exports = __webpack_public_path__ + "static/media/BTECH_EXTC_2023-2027_Scheme.5924f40a.pdf";